import React, { useEffect, useState } from "react";
import i18next from "i18next";
import { Grid, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { isEmpty } from "lodash";
import EAButton from "../../../../components/common/EAButton";
import useStyles from "../../../../style/js-style/containers/administration/rules/RuleFormsStyle";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import EARuleAccordion from "../../../../components/rules/EARuleAccordion";
import RuleActions from "../form/actions/RuleActions";
import RuleActivationErrors from "components/rules/RuleActivationErrors";

const RuleAction = ({
  open,
  onCancel,
  onContinue,
  disabled,
  readOnly = false
}) => {
  const { classes } = useStyles();

  const [isContinueClicked, setIsContinueClicked] = useState(false);
  const formMethods = useFormContext();
  const { trigger, getValues, formState } = formMethods;

  const ruleType = getValues('type');

  // Trigger actions errors with debounce to avoid multiple button clicks
  const handleContinue = AwesomeDebouncePromise(() => {
    trigger(["actions"]);
    setIsContinueClicked(true);
  }, [100]);

  // We continue to next step if the validation is done and no errors are found.
  useEffect(() => {
    if (
      isContinueClicked &&
      !formState.isValidating &&
      isEmpty(formState.errors)
    ) {
      onContinue();
    }
    setIsContinueClicked(false);
  }, [isContinueClicked, formState, onContinue]);

  return (
    <EARuleAccordion
      buttons={[]}
      title={i18next.t('rules.action.title')}
      icon="action"
      opened={open}
      disabled={disabled}
    >
      <RuleActivationErrors
                  actionsListEmpty={false}
                  noDossierSelected={false}
                  hasEmptyRefs={false}
                  onActionsListEmptyClose={() => {}}
                  onNoDossierSelectedClose={() => {}}
                  onEmptyRefsClose={() => {}}
                  multipleSameActionNotAllowed={false}
                  onMultipleSameActionNotAllowedClose={
                    () => {}
                  }
                />
      {/* Rule actions */}
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Grid container spacing={2} style={{ padding: '16px 0 0 16px'}}>
            <Grid item xs={12} sx={{ paddingTop: '0!important' }}>
              <Typography variant={`h6`} className={classes.formSectionTitle} >
                <span className={classes.formSectionTitleDeco} />
                {i18next.t('rules.action.label')}
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ marginTop: 8}}>
            {/* <ActionsFormArray /> */}
              <RuleActions 
                fieldName={`actions`}
                ruleType={ruleType}
                readOnly={readOnly}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* Buttons */}
      {!readOnly &&
        <div className={classes.configurationButtonWrapper}>
          <EAButton
            onClick={(e) => {
              e.preventDefault();
              onCancel();
            }}
            content={i18next.t('rules.configuration.actions.cancel')}
            colorVariant="secondary"
            customStyle={{
              minWidth: '66px',
              fontSize: '14px',
              minHeight: '32px',
              height: '32px',
              padding: 0,
              borderRadius: '12px',
            }}
          />

          <EAButton
            onClick={(e) => {
              e.preventDefault();
              handleContinue();
            }}
            disabled={!isEmpty(formState.errors)}
            content={i18next.t('rules.configuration.actions.validate')}
            customStyle={{
              fontSize: '14px',
              minWidth: '94px',
              minHeight: '32px',
              height: '32px',
              padding: '0 10px',
              borderRadius: '12px',
            }}
          />
        </div>
      }
    </EARuleAccordion>
  );
};

export default RuleAction;
